export const WIX_SOCIAL_BLOG_SCOPE = 'wix-social-blog';
